import React, { useEffect, useState } from 'react'
import { ServerRequestProtected, ServerRequestProtectedOCR } from '../../utils/ServerDataRequest'
import NotificationHandler from '../../utils/NotificationHandler'
import Loader from '../shared/Loader/Loader'
import { enumUtil } from '../../utils/Enum'
import isNull from '../../utils/NullChecking'
import AmountFormatter from '../../utils/AmountFormatter'
import { useSelector } from 'react-redux'
function Pdfdetail(props) {

    let { isOpenRegistry, onClosee, OCRFile, OCRType, ApplyFileChanges, LoadCounties } = { ...props }

    const API_URL_Claim = enumUtil.controller.Claim
    const API_URL = enumUtil.controller.OCR;
    const API_URL_Search = enumUtil.controller.General
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id

    let OCR_PDF_MODAL = {
        description: '',
        modifier: '',
        quantity: "",
        procedureCode: "",
        totalQuantity: "",
        totalProcedureQty: "",
        startDate: "",
        endDate: "",
        patientAuthorizationID: "",
        authStatus: "",
        unitsFrequency: "",
        mon: "",
        wed: "",
        fri: "",
        service: "",
        memberMedicaidNo: "",
        memberMedicareNo: "",
        primaryDxCode: "",
        primaryDxDescription: "",
        memberPCP: "",
        memberPrimaryLanguage: "",
        memberGender: "",
        memberName: "",
        memberDOB: "",
        memberAge: "",
        memberAddress: "",
        memberHome: "",
        memberCell: "",
        memberOther: "",
        city: "",
        state: "",
        zip: "",
        providerNPI: "",
        providerTaxID: "",
        provider: "",
        phone: "",
        date: "",
        providerServiceLine: "",
        memberNo: "",
        memberPrimaryDX: null,
        memberNPI: "",
        special_instruction: null,
        tue: "0",
        thu: "0",
        sat: "0",
        sun: "0",
        codes: null,
        serviceCodeModifiers: null,
        descriptions: null,
        fromDates: null,
        toDates: null,
        apprUnits: null,
        units: null,
        stautses: null,
        DiagnosisCode1ID: '',
        DiagnosisCode2ID: '',
        DiagnosisCode3ID: '',
        DiagnosisCode4ID: '',
    }

    const [isLoading, setIsLoading] = useState(false);
    const [OcrPdfData, setOcrPdfData] = useState(OCR_PDF_MODAL);
    const [isFileExist, setIsFileExist] = useState(false);

    //Load Counties
    // const LoadCounties = (insuranceid, cptid, type, selectedData) => {
    //     let modal = { ...AuthMainModal };
    //     let SaveModal = { ...AuthSaveModal }
    //     modal['ProcedureCode'] = selectedData.display
    //     modal['ProcedureCodeID'] = selectedData.display
    //     SaveModal['ProcedureCode'] = selectedData.display + "";
    //     SaveModal['ProcedureCodeID'] = selectedData.value + "";
    //     if (isHomeCareCheck === 'true') {
    //         ServerRequestProtected(API_URL_Search + "/Dropdown", 'post', {
    //             "TableName": enumUtil.enumAPITableName.ProgramType,
    //             "SearchCriteria": {
    //                 "PatientID": PateintIDR + "",
    //                 "ProcedureCodeID": !isNull(cptid) ? cptid + "" : '',
    //                 "InsuranceID": !isNull(insuranceid) ? insuranceid + "" : ''
    //             }
    //         }).then((response) => {
    //             setOverAllDD(response)
    //             if (type === 'ProcedureCode' && response.length > 0) {
    //                 if (ProgramTypeDD.length === 2) {
    //                     let data = response.filter(item => item.InsuranceType === ProgramTypeDD[1].value + "");
    //                     let defaultOption = { value: '-1', display: 'Select Type' };
    //                     data.unshift(defaultOption);
    //                     setCountyDD(data)
    //                     modal['InsuranceType'] = ProgramTypeDD[1].value
    //                     if (data.length === 2) {
    //                         modal['ProviderFeeScheduleID'] = data[1].display
    //                         modal['CountyAmount'] = data[1].Amount
    //                         SaveModal['ProviderFeeScheduleID'] = data[1].value + ""
    //                         setBillingEntityID(data[1].BillingEntityID + "")
    //                     } else {
    //                         const filteredCounties = data.filter((item) => {
    //                             return item.display.split(',').some(county => county.trim() === AuthMainModal.PatientCounty);
    //                         });
    //                         if (filteredCounties.length > 0) {
    //                             let ptCounty = filteredCounties[0].display.split(',')
    //                             modal['CountyAmount'] = filteredCounties[0].Amount;
    //                             modal['ProviderFeeScheduleID'] = filteredCounties[0].display;
    //                             SaveModal['ProviderFeeScheduleID'] = filteredCounties[0].value + "";
    //                             setBillingEntityID(filteredCounties[0].BillingEntityID + "")
    //                         } else {
    //                             modal['CountyAmount'] = ''
    //                             modal['ProviderFeeScheduleID'] = ''
    //                             SaveModal['ProviderFeeScheduleID'] = ''
    //                             setBillingEntityID("")
    //                         }
    //                     }
    //                 } else {
    //                     modal['ProviderFeeScheduleID'] = ''
    //                     modal['InsuranceType'] = ''
    //                     modal['CountyAmount'] = ''
    //                     SaveModal['ProviderFeeScheduleID'] = ''
    //                     setBillingEntityID("")
    //                     setCountyDD([])
    //                 }
    //             }
    //         }).catch((error) => {
    //             // let modal = { ...mainAuthorizationModal };
    //             // let SaveModal = { ...AuthorizationSaveUpdateModal }
    //             modal['ProviderFeeScheduleID'] = ''
    //             modal['InsuranceType'] = ''
    //             modal['CountyAmount'] = ''
    //             SaveModal['ProviderFeeScheduleID'] = ''
    //             // setmainAuthorizationModal(modal)
    //             // setAuthorizationSaveUpdateModal(SaveModal)
    //             setBillingEntityID("")
    //             setOverAllDD([])
    //             setCountyDD([])
    //             // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    //         })
    //     }

    //     setMainModal(modal)
    //     setSaveModal(SaveModal)
    // }

    const handleApply = () => {
        if (ApplyFileChanges) {
            // if (isFileExist && ApplyFileChanges) {
            ApplyFileChanges(OcrPdfData);
            onClosee();
        }
    }
    const GetDiagnosCodeDetails = async (code) => {
        if (!isNull(code)) {
            try {
                const response = await ServerRequestProtected(
                    API_URL_Claim + "/ICDInstantSearch",
                    'post',
                    {
                        "TableName": enumUtil.enumAPITableName.Diagnosis,
                        "SearchParam": code
                    }
                );
                return response?.[0]?.value + "" || '';
            } catch (error) {
                console.error(`Error fetching diagnosis code ${code}:`, error);
                return '';
            }
        }
        return null;
    };
    useEffect(() => {
        if (OCRType) {
            setIsLoading(true);
            setIsFileExist(false);

            const processOCRData = async () => {
                try {
                    const response = await ServerRequestProtectedOCR('api/' + API_URL + "/GetOCRPDFData", 'post', {
                        "Base64": OCRFile,
                        "OCRType": OCRType
                    });

                    let modal = { ...response };

                    // Process diagnosis codes in parallel
                    const diagnosisCodes = [
                        response?.diagnosisCode1,
                        response?.diagnosisCode2,
                        response?.diagnosisCode3,
                        response?.diagnosisCode4
                    ];

                    const diagnosisResults = await Promise.all(
                        diagnosisCodes.map(code => GetDiagnosCodeDetails(code))
                    );

                    // Assign results to modal
                    if (isNull(diagnosisResults[0])) {
                        modal['DiagnosisCode1ID'] = null;
                        modal['diagnosisCode1'] = null;
                    } else {
                        modal['DiagnosisCode1ID'] = diagnosisResults[0];
                    }
                    if (isNull(diagnosisResults[1])) {
                        modal['DiagnosisCode2ID'] = null;
                        modal['diagnosisCode2'] = null;
                    } else {
                        modal['DiagnosisCode2ID'] = diagnosisResults[1];
                    }
                    if (isNull(diagnosisResults[2])) {
                        modal['DiagnosisCode3ID'] = null;
                        modal['diagnosisCode3'] = null;
                    } else {
                        modal['DiagnosisCode3ID'] = diagnosisResults[2];
                    }
                    if (isNull(diagnosisResults[3])) {
                        modal['DiagnosisCode4ID'] = null;
                        modal['diagnosisCode3'] = null;
                    } else {
                        modal['DiagnosisCode4ID'] = diagnosisResults[3];
                    }
                    console.log('modal after diagnosis processing:', modal);

                    // Process procedure code
                    const ProcedureCode = response?.cptDetailslist[0]?.codes;
                    if (ProcedureCode && ProcedureCode?.length > 0) {
                        try {
                            const API_Link = API_URL_Claim + "/ICDInstantSearch";
                            const postBody = { "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": ProcedureCode };

                            const cptRespone = await ServerRequestProtected(API_Link, 'post', postBody);
                            const cptOBJ = cptRespone?.[0];
                            const cptID = cptRespone?.[0]?.['value'];

                            // Load Counties
                            LoadCounties(cptID + "", 'ProcedureCode', cptOBJ);
                            setIsFileExist(true);
                        } catch (error) {
                            console.error('Error fetching procedure code:', error);
                        }
                    } else {
                        setIsFileExist(false);
                    }

                    setOcrPdfData(modal);
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                    setIsFileExist(false);
                    NotificationHandler(error.response?.data?.error || 'An error occurred', enumUtil.enumtoaster.error);
                }
            };

            processOCRData();
        }
    }, []);

    return (
        <React.Fragment>
            <div className={`npi-panel npi-open npi_detail_popup ${isOpenRegistry ? 'ar-pdf-modal' : 'npi-panel'}`}
                style={{ "z-index": "3000" }}>
                {isLoading ? <Loader /> : null}
                <div className='npi-panel__header mb-10'>
                    <p className="heading fs-12">Auth Details</p>
                    <div className='d-flex'>
                        <button className="btn-icon-transparent" onClick={onClosee}><i className="icon-Icon-metro-cross"></i></button>
                    </div>
                </div>
                <div className='ar-npi-content'>
                    <div className='row m-0 px-10'>
                        <div className="col-md-5 px-0 d-flex flex-column row-gap-8">
                            <div>
                                <p className='heading mb-1 provider-heading fs-12'>Provider Information</p>
                                <div className='d-flex flex-column row-gap-5 br-bottom-1 za_br_light pb-1'>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Name</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.provider}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>NPI</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.providerNPI}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Tax ID</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.providerTaxID}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Fax</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.fax}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Phone #</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.providerPhone ? OcrPdfData?.providerPhone : '-'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='d-flex flex-column row-gap-5 br-bottom-1 za_br_light pb-1'>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Payer</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text font-m'>{OcrPdfData?.payer} <span className='ar-light-color fs-10'>{OcrPdfData?.payerPhone ? `(${OcrPdfData?.payerPhone})` : ''}</span></p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Address</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.payerAddress}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='d-flex flex-column row-gap-5 br-bottom-1 za_br_light pb-1'>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Auth #</p>
                                        </div>
                                        <div className='col-md-9 d-flex align-items-center gap-10'>
                                            <p className='fs-11 text'>{OcrPdfData?.authorizationNo}
                                                <span className='ms-1 ar-light-color'>{OcrPdfData?.cptDetailslist?.length > 0
                                                    ? `${OcrPdfData?.cptDetailslist[0].fromDates} - ${OcrPdfData?.cptDetailslist[0].toDates}`
                                                    : ''}</span>
                                            </p>
                                            {OcrPdfData?.authStatus ? <p className='text fs-10 font-m fst-italic complete'>{OcrPdfData?.authStatus}</p> : <></>}
                                        </div>
                                    </div>

                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Total Qty</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.totalQuantity}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Freq.</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.unitsFrequency}</p>
                                        </div>
                                    </div>

                                    {/* <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text ar-light-color'>Phone #</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.phone}</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className=''>
                                <div className='row gx-0 m-0'>
                                    <div className='col-md-3'>
                                        <p className='fs-11 font-m text'>Special Ins.</p>
                                    </div>
                                    <div className='col-md-9 d-flex align-items-center gap-10'>
                                        <p className='fs-11 text'>{OcrPdfData?.special_instruction}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7 ps-2 pe-0">
                            <div className='ar-blue-content mb-2'>
                                <p className='heading pb-1 fs-12'>Member Information</p>
                                <div className='d-flex flex-column row-gap-5 br-bottom-1 za_br_light pb-2 mb-2'>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Name</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text d-flex align-items-center gap-2'>{OcrPdfData?.memberName} <span className='ar-light-color font-m'>{OcrPdfData?.memberDOB ? `(${OcrPdfData?.memberDOB})` : ''}</span> <span className='ar-light-color font-m'>{OcrPdfData?.memberGender}</span></p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>NPI</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.memberNPI}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className="col-md-7 d-flex">
                                            <div className='col-md-5'>
                                                <p className='fs-11 font-m text'>Prim. Lang :</p>
                                            </div>
                                            <div className='col-md-7 ps-1'>
                                                <p className='fs-11 text'>{OcrPdfData?.memberPrimaryLanguage}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-5 d-flex">
                                            <div className='col-md-4'>
                                                <p className='fs-11 font-m text'>Cell # :</p>
                                            </div>
                                            <div className='col-md-9'>
                                                <p className='fs-11 text'>{OcrPdfData?.memberCell ? OcrPdfData?.memberCell : OcrPdfData?.memberHome}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Address :</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.memberAddress}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Member ID :</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.memberNo}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Medicaid #</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.memberMedicaidNo}</p>
                                        </div>
                                    </div>
                                    <div className='row gx-0 m-0'>
                                        <div className='col-md-3'>
                                            <p className='fs-11 font-m text'>Medicare #</p>
                                        </div>
                                        <div className='col-md-9'>
                                            <p className='fs-11 text'>{OcrPdfData?.memberMedicareNo}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex flex-column row-gap-5 br-bottom-1 za_br_light pb-1 mb-1'>
                                    <p className='heading fs-12'>Diagnosis Code</p>
                                    {OcrPdfData?.primaryDxCode ?
                                        <p className='text fs-11'>{OcrPdfData?.primaryDxCode} </p>
                                        :
                                        <p className='text fs-11 fst-italic light-clrs'>N/A</p>
                                    }

                                </div>
                                <div className='d-flex flex-column row-gap-5'>
                                    <div>
                                        <p className='heading fs-12'>Procedure Code(s)</p>
                                        <div className='d-flex flex-column row-gap-5'>
                                            <div className='row gx-0 m-0'>
                                                {/* <div className='col-md-3'>
                                            <p className='fs-11 font-m text ar-light-color'>Code</p>
                                        </div> */}
                                                <div className='col-md-9'>
                                                    {OcrPdfData?.cptDetailslist?.length > 0 ? (
                                                        OcrPdfData?.cptDetailslist?.map((item, index) => (
                                                            <p key={index} className='fs-11 text d-flex align-items-center gap-2'>
                                                                {item.codes} - {item.descriptions}
                                                            </p>
                                                        ))
                                                    ) : (
                                                        <p className='text fs-11 fst-italic light-clrs'>N/A</p>
                                                    )}
                                                    {/* {OcrPdfData?.cptDetailslist.length === 1 ? OcrPdfData?.cptDetailslist[0].codes : ''} */}

                                                </div>
                                            </div>
                                            <div className='row gx-0 m-0'>
                                                {/* <div className='col-md-3'>
                                            <p className='fs-11 font-m text ar-light-color'>Description</p>
                                        </div> */}
                                                <div className='col-md-9'>
                                                    <p className='fs-11 text d-flex align-items-center gap-2'>
                                                        {/* {OcrPdfData?.description} */}
                                                        {/* {OcrPdfData?.cptDetailslist?.map((item) => {
                                                    return (
                                                        item.descriptions
                                                    )
                                                })} */}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='text-end npi-panel__footer pt-2'>
                    <button className='btn btn-orange btn-sm' onClick={handleApply}>Apply</button>
                </div>
            </div>
        </React.Fragment>

    )
}
export default Pdfdetail